const nav = [
  {
    children: "Background",
    href: "/",
    id: 1,
  },

  {
    children: "User Groups",
    href: "/users",
    id: 2,
  },
  {
    children: "Customer Setup",
    href: "/customer",
    id: 3,
  },

  {
    children: "Application",
    href: "/demo",
    id: 4,
  },
];

export default nav;
